import React, { useState } from 'react';
import { DEFAULT_TEAM_LOGO } from '@/model/constant';

interface TeamLogoProps {
  src?: string;
  className?: string;
  alt?: string;
}

/**
 * 球队 logo
 * src 为空或加载失败时，使用默认 logo
 */
const TeamLogo = ({ src, className, alt = '' }: TeamLogoProps) => {
  const [erroredSrc, setErroredSrc] = useState<string | undefined>();
  const logo = !src || erroredSrc === src ? DEFAULT_TEAM_LOGO : src;

  return (
    <img
      className={className}
      src={logo}
      alt={alt}
      onError={() => {
        if (erroredSrc !== src) {
          setErroredSrc(src);
        }
      }}
    />
  );
};

export default TeamLogo;
